import React, { useState } from 'react';
import './ComingSoonLoader.css';

const ComingSoonLoader = ({ onUnlock, theme }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.toLowerCase() === 'hola') {
      onUnlock();
    }
  };

  const overlayStyle = {
    backgroundColor: theme ? theme.palette.background.default : 'rgba(10, 10, 25, 0.95)',
  };

  return (
    <div className="coming-soon-overlay" style={overlayStyle}>
      <div className="coming-soon-content">
        <h1 className="coming-soon-text" style={{ color: theme ? theme.palette.text.primary : '#fff' }}>
          Coming Soon
        </h1>
      </div>
      <div className="unlock-box">
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          placeholder="Type the magic word..."
          className="unlock-input"
        />
      </div>
    </div>
  );
};

export default ComingSoonLoader;
